const SUCCESS_STRING = 'SUCCESS';

export const ValidationStrategies = {
  OBJECT_EXISTS: 'OBJECT_EXISTS',
  SUCCESS_KEY: 'SUCCESS_KEY',
  ALWAYS_TRUE: 'ALWAYS_TRUE',
  ALWAYS_FALSE: 'ALWAYS_FALSE',
}

export const validateResponse = (response, validationStrategy = ValidationStrategies.OBJECT_EXISTS) => {
  switch(validationStrategy) {
    case ValidationStrategies.OBJECT_EXISTS: {
      return objectExistsMethod(response);
    }
    case ValidationStrategies.SUCCESS_KEY: {
      return successKeyMethod(response);
    }
    case ValidationStrategies.ALWAYS_TRUE: {
      return (data) => true;
    }
    case ValidationStrategies.ALWAYS_FALSE: {
      return (data) => false;
    }
    default: {
      return (data) => false;
    }
  }
};


export const successKeyMethod = (data) => {
  if (Object.keys(data).includes(SUCCESS_STRING)) {
    return true;
  } else {
    return false;
  }
};

const objectExistsMethod = (data) => {
  if (data) {
    return true;
  } else {
    return false;
  }
};